import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";

const messages = defineMessages({
  webAppBasics1: {
    id: "guides.gettingStarted.checklist.webAppBasics.step1",
    defaultMessage: "Companies",
  },
  webAppBasics1Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step1.description",
    defaultMessage:
      "Here you can find a list of all your companies. You can sort it and filter by different criteria.",
  },
  webAppBasics2: {
    id: "guides.gettingStarted.checklist.webAppBasics.step2",
    defaultMessage: "Companies",
  },
  webAppBasics2Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step2.description",
    defaultMessage:
      "Clicking here, you can toggle a column selection panel to show only the ones you currently need.",
  },
  webAppBasics3: {
    id: "guides.gettingStarted.checklist.webAppBasics.step3",
    defaultMessage: "Planner",
  },
  webAppBasics3Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step3.description",
    defaultMessage:
      "On this page you can find all your activities. You can filter them, and switch between month, week, and day views.",
  },
  webAppBasics4: {
    id: "guides.gettingStarted.checklist.webAppBasics.step4",
    defaultMessage: "Planner",
  },
  webAppBasics4Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step4.description",
    defaultMessage:
      "You can click and drag to add an activity. Or change existing activity's start or end time.",
  },
  webAppBasics5: {
    id: "guides.gettingStarted.checklist.webAppBasics.step5",
    defaultMessage: "Map",
  },
  webAppBasics5Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step5.description",
    defaultMessage:
      "Here you can find all your records displayed on a map. Feel free to filter them using various filtering criteria.",
  },
  webAppBasics6: {
    id: "guides.gettingStarted.checklist.webAppBasics.step6",
    defaultMessage: "Map",
  },
  webAppBasics6Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step6.description",
    defaultMessage: "Click on pins to see additional information.",
  },
  webAppBasics7: {
    id: "guides.gettingStarted.checklist.webAppBasics.step7",
    defaultMessage: "Universal search",
  },
  webAppBasics7Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step7.description",
    defaultMessage: "Use search to find any record or to see your recently opened ones.",
  },
  webAppBasics8: {
    id: "guides.gettingStarted.checklist.webAppBasics.step8",
    defaultMessage: "Universal add",
  },
  webAppBasics8Description: {
    id: "guides.gettingStarted.checklist.webAppBasics.step8.description",
    defaultMessage: "You can add new record from any page from this menu.",
  },
});

export const repsWebAppBasicsTour: TourDescriptor = {
  id: "getting-started-reps-web-app-basics",
  steps: [
    {
      id: "companies",
      description: messages.webAppBasics1Description,
      position: "right",
      selector: "[data-element-id=page-title]",
      title: messages.webAppBasics1,
    },
    {
      id: "companies-columns",
      description: messages.webAppBasics2Description,
      selector: "[data-action-id=select-columns-button]",
      title: messages.webAppBasics2,
    },
    {
      id: "planner",
      description: messages.webAppBasics3Description,
      goToPathBefore: "/activity/calendar",
      selector: "[data-element-id=page-title]",
      title: messages.webAppBasics3,
    },
    {
      id: "planner-calendar",
      description: messages.webAppBasics4Description,
      title: messages.webAppBasics4,
    },
    {
      id: "map",
      description: messages.webAppBasics5Description,
      goToPathBefore: "/map",
      selector: "#map-filter-button",
      title: messages.webAppBasics5,
    },
    {
      id: "map-pins",
      description: messages.webAppBasics6Description,
      title: messages.webAppBasics6,
    },
    {
      id: "global-search",
      description: messages.webAppBasics7Description,
      selector: "[data-action-id=global-search]",
      title: messages.webAppBasics7,
    },
    {
      id: "global-add",
      description: messages.webAppBasics8Description,
      selector: "[data-action-id=global-add-menu]",
      title: messages.webAppBasics8,
    },
  ],
};
